module.exports = __webpack_public_path__ + "static/media/battery.2c202136.svg";